import { render, staticRenderFns } from "./Auftraege_Freigabe_Offen.vue?vue&type=template&id=c05238ca&scoped=true"
import script from "./Auftraege_Freigabe_Offen.vue?vue&type=script&lang=js"
export * from "./Auftraege_Freigabe_Offen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05238ca",
  null
  
)

export default component.exports